// This icon file is generated automatically.
var PInfoCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }, { "tag": "path", "attrs": { "d": "M6.25 4.25a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM7.38 6h-.75a.13.13 0 00-.13.13v4.25c0 .06.06.12.13.12h.75c.06 0 .12-.06.12-.13V6.13A.13.13 0 007.37 6z" } }] }] }, "name": "p-info-circle", "theme": "outlined" };
export default PInfoCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PInfoCircleOutlined.js
// module id = 3465
// module chunks = 0